<template>
  <div class="forget-password">
    <div>
      <md-field>
        <md-tabs v-model="activeName">
          <md-tab-pane name="mobile" :label="$t('mobileNumber')">
            <div v-if="activeName === 'mobile'">
              <md-field-item :title="$t('mobileNumber')"></md-field-item>
              <md-input-item
                type="digit"
                v-model="form.mobile"
                class="mobile-input bordered"
                name="mobileNumber"
                v-validate="'required|betweenLength:8,13'"
                placeholder="">
                <div slot="left" class="mobile-prefix" @click="showSelector">
                  <span class="prefix-text">{{form.mobileCountry}}</span>
                  <md-icon name="arrow-down" size="sm"></md-icon>
                </div>
              </md-input-item>
            </div>
            <span class="danger">{{ errors.first('mobileNumber') }}</span>
          </md-tab-pane>
          <md-tab-pane name="email" :label="$t('email')">
            <div v-if="activeName === 'email'">
              <md-field-item :title="$t('email')"></md-field-item>
              <md-input-item
                class="bordered"
                name="email"
                type="text"
                :class="{'danger':errors.first('email')}"
                v-model="form.email"
                v-validate="'required|email'"
                data-vv-as="email">
              </md-input-item>
            </div>
            <span class="danger">{{ errors.first('email') }}</span>
          </md-tab-pane>
        </md-tabs>
        <md-field-item :title="$t('verificationCode')">
        </md-field-item>
        <md-input-item
          class="bordered verification-code"
          name="verificationCode"
          type="text"
          v-model="form.otp"
          v-validate="'required|digits:6'">
          <md-button
            slot="right"
            type="blue"
            :inactive="!form.email && !form.mobile || !!otpInterval"
            @click="getOTP"
          >
            {{ otpButtonText }}
          </md-button>
        </md-input-item>
        <span class="danger">{{ errors.first('verificationCode') }}</span>
        <md-field-item :title="$t('password')"></md-field-item>
        <md-input-item
          class="bordered"
          type="password"
          name="password"
          v-model="form.password"
          v-validate="'required|betweenLength:8,16'">
        </md-input-item>
        <span class="danger">{{ errors.first('password') }}</span>
      </md-field>
      <md-selector
        class="mobile-prefix-selector"
        v-model="selectorVisible"
        :data="mobilePrefixList"
        default-value="+62"
        cancel-text="cancel"
        title="Mobile Prefix"
        max-height="400px"
        @choose="onSelectorChoose($event)"
      ></md-selector>
    </div>
    <div>
      <button-primary type="primary" :loading="loading" class="button-submit" @click="submit">
        {{ $t('next') }}
      </button-primary>
    </div>
  </div>
</template>

<script>
import { Field, FieldItem, Icon, InputItem, Selector, Button, Tabs, TabPane } from 'mand-mobile'

export default {
  components: {
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  i18n: {
    messages: {
      en: {
        checkInfo: 'Invalid input, please check again',
        email: 'Email',
        invalidEmail: 'Invalid email address',
        invalidMobile: 'Mobile number should be 8 - 13 digits.',
        invalidPassword: 'Password should be 8 - 16 characters.',
        invalidVerificationCode: 'Invalid code',
        mobileNumber: 'Mobile Number',
        next: 'Next',
        password: 'Password',
        resend: 'Resend',
        resetSuccessfully: 'Reset password successfully. Please check your inbox.',
        send: 'Send',
        verificationCode: 'Verification Code',
        verificationCodeSent: 'The verification code has been sent. Please Kindly check.',
      },
      id: {
        checkInfo: 'Masukan tidak valid, silakan periksa info Anda',
        email: 'Email',
        invalidEmail: 'Email tidak valid',
        invalidMobile: 'Nomor telepon harus 8 - 13 digit',
        invalidPassword: 'Kata sandi harus terdiri dari 8 - 16 digit dan angka',
        invalidVerificationCode: 'Kode salah',
        mobileNumber: 'Nomor Ponsel',
        next: 'berikutnya',
        password: 'Kata Sandi',
        resend: 'Kirim ulang',
        resetSuccessfully: 'Reset password successfully. Please check your inbox.',
        send: 'Kirim',
        verificationCode: 'Kode Verifikasi',
        verificationCodeSent: 'Kode verifikasi telah dikirim. Silakan periksa.',
      },
    },
  },
  data() {
    return {
      defaultIndex: 0,
      form: {
        email: '',
        mobileCountry: '+62',
        mobile: '',
        otp: '',
        password: '',
      },
      activeName: 'mobile',
      mobilePrefixList: [
        {
          text: '+61',
          value: '+61',
        },
        {
          text: '+62',
          value: '+62',
        },
        {
          text: '+65',
          value: '+65',
        },
        {
          text: '+81',
          value: '+81',
        },
        {
          text: '+82',
          value: '+82',
        },
        {
          text: '+852',
          value: '+852',
        },
        {
          text: '+86',
          value: '+86',
        },
        {
          text: '+886',
          value: '+886',
        },
      ],
      selectorVisible: false,
      otpCountdown: null,
      otpInterval: null,
      loading: false,
    }
  },
  computed: {
    otpButtonText() {
      if (this.otpCountdown === null) {
        return this.$t('send')
      }
      if (this.otpCountdown <= 0) {
        return this.$t('resend')
      }
      return `${this.otpCountdown}s`
    },
  },
  methods: {
    showSelector() {
      this.selectorVisible = true
    },
    onSelectorChoose({ text }) {
      this.form.mobileCountry = text
    },
    stopCountdown() {
      if (this.otpInterval) {
        clearInterval(this.otpInterval)
        this.otpInterval = null
      }
      this.otpCountdown = 0
    },
    startCountdown() {
      this.stopCountdown()
      this.otpCountdown = 60
      this.otpInterval = setInterval(() => {
        this.otpCountdown -= 1
        if (this.otpCountdown === 0) {
          clearInterval(this.otpInterval)
          this.otpInterval = null
        }
      }, 1000)
    },
    async getOTP() {
      this.startCountdown()

      const url = {
        email: `/auth/reset-password-email?email=${this.form.email}`,
        mobile: `/auth/reset-password-code?phone=${this.form.mobileCountry}${this.form.mobile}`,
      }[this.activeName]

      try {
        this.$toast.loading('loading...')
        const res = await this.$http.post(url)
        switch (res.data.code) {
          case 'SUCCESS': {
            this.$toast.succeed(this.$t('verificationCodeSent'))
            break
          }
          default: {
            this.stopCountdown()
            this.$toast.info(this.$t('checkInfo'))
            break
          }
        }
      } catch (error) {
        console.error(error)
        this.stopCountdown()
      } finally {
        this.$toast.hide()
      }
    },
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      try {
        this.loading = true
        const username = {
          email: this.form.email,
          mobile: `${this.form.mobileCountry}${this.form.mobile}`,
        }[this.activeName]
        const payload = {
          username: username.trim(),
          code: this.form.otp,
          password: this.form.password,
        }
        await this.$http.post('/auth/forget-password', payload)
        this.$toast.succeed(this.$t('resetSuccessfully'))
        this.$router.push('/login')
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.button-submit {
  margin-top: 10px;
}

.forget-password /deep/ {
  background-color: #fff;
  padding: 30px 20px;
  min-height: calc(100vh - 64px);
  .md-input-item.danger {
    border: 1px solid color-text-error;
  }
  .md-button.blue {
    background-color: #5C9DE7;
  }
}
</style>
